// import { Dom, Event, Text, Type } from 'main.core';
// import LazyLoader from './lazy-loader';

import ProductBonusProgram from '../entity/ProductBonusProgram'
import GeneralBonusProgram from '../entity/GeneralBonusProgram'
export default class BonusProgram {
    defaultOptions: Object

    constructor(params) {
        // debugger
        this.ID = params.ID
        this.SORT = params.SORT || 100
        this.XML_ID = params.XML_ID
        this.NAME = params.NAME
        this.CODE = params.CODE
        this.DESCRIPTION = params.DESCRIPTION
        this.HELP = params.HELP
        this.IMAGE = params.IMAGE
        this.TYPE = params.TYPE
        this.ITEMS = params.ITEMS
        this.CONTRAGENTS = params.CONTRAGENTS
        this.USERS = params.USERS

        switch (this.TYPE) {
            case "PRODUCT":
                break;
            case "GENERAL":
                break;
            default:
                break;
        }
    }

    isPossibileToUse = function (params) {
        let result = true;
        if (result && typeof params.product === 'object' && params.product !== null) {
            result &&= this.isPossibileForProduct(params.product);
        }
        if (result && typeof params.contragent === 'object' && params.contragent !== null) {
            result &&= this.isPossibileForContragent(params.contragent);
        }
        if (result && typeof params.user === 'object' && params.user !== null) {
            result &&= this.isPossibileForUser(params.user);
        }
        return result;
    }
    isPossibileForProduct = function (product) {
        let result = true;
        if (typeof this.ITEMS !== 'undefined' && this.ITEMS.length) {
            result = false;
            if (this.ITEMS.find(v => v == product.PRODUCT_XML_ID))
                result = true;
        }
        return result;
    }

    isPossibileForContragent = function (contragent) {
        let result = true;
        if (typeof this.CONTRAGENTS !== 'undefined' && this.CONTRAGENTS.length) {
            result = false;
            for (const i in this.CONTRAGENTS) {
                if (Object.hasOwnProperty.call(this.CONTRAGENTS, i)
                    && this.CONTRAGENTS[i]?.CONTRAGENT?.UF_XML_ID == contragent.UF_XML_ID
                ) {
                    result = true;
                    break;
                }
            }
        }
        return result;
    }

    isPossibileForUser = function (user) {
        let result = true;
        if (typeof this.USERS !== 'undefined' && this.USERS.length) {
            result = false;
            for (const i in this.USERS) {
                if (Object.hasOwnProperty.call(this.USERS, i)
                    && this.USERS[i].XML_ID == user.XML_ID
                ) {
                    result = true;
                    break;
                }
            }
        }
        return result;
    }
}
